import { Box, Button, TextField, withStyles } from "@mui/material";
import React, { useState } from "react";

//   const CssTextField = withStyles({
//     root: {
//       "& label.Mui-focused": {
//         color: "white",
//       },
//       "& .MuiInput-underline:after": {
//         borderBottomColor: "white",
//       },
//       "& .MuiOutlinedInput-root": {
//         "& fieldset": {
//           borderColor: "white",
//         },
//         "&:hover fieldset": {
//           borderColor: "white",
//         },
//         "&.Mui-focused fieldset": {
//           borderColor: "white",
//         },
//       },
//     },
//   })(TextField);

function Form() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    website: "",
    platform: "",
    monthlySales: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    console.log(formData);
    e.preventDefault();
    const response = await fetch("https://formspree.io/f/xyyapkgy", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    if (response.ok) {
      console.log("Form submitted successfully");
      setFormData({
        name: "",
        phone: "",
        email: "",
        website: "",
        platform: "",
        monthlySales: "",
      });
    } else {
      console.error("Error submitting form");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box
        sx={{
          display: "flex",
          width: { xs: "90vw", md: "40vw" },
          margin: "5px",
          justifyContent: "space-between",
        }}
      >
        <TextField
          required
          sx={{ width: { xs: "44vw", md: "19vw" } }}
          type="text"
          label="Name"
          name="name"
          variant="outlined"
          value={formData.name}
          onChange={handleChange}
        />
        <TextField
          required
          sx={{ width: { xs: "44vw", md: "19vw" } }}
          type="text"
          label="Phone"
          name="phone"
          variant="outlined"
          value={formData.phone}
          onChange={handleChange}
        />
      </Box>
      <TextField
        required
        sx={{ width: { xs: "90vw", md: "40vw" }, margin: "5px" }}
        type="text"
        label="Business Email"
        variant="outlined"
        name="email"
        value={formData.email}
        onChange={handleChange}
      />
      <br />
      <TextField
        sx={{ width: { xs: "90vw", md: "40vw" }, margin: "5px" }}
        type="text"
        label="D2C Website"
        variant="outlined"
        name="website"
        value={formData.website}
        onChange={handleChange}
      />
      <br />
      <TextField
        sx={{ width: { xs: "90vw", md: "40vw" }, margin: "5px" }}
        type="text"
        label="Platform"
        variant="outlined"
        name="platform"
        value={formData.platform}
        onChange={handleChange}
      />
      <br />
      <TextField
        sx={{ width: { xs: "90vw", md: "40vw" }, margin: "5px" }}
        type="text"
        label="Average monthly sales"
        variant="outlined"
        name="monthlySales"
        value={formData.monthlySales}
        onChange={handleChange}
      />
      <br />
      <Button
        type="submit"
        variant="contained"
        color="primary"
        size="large"
        sx={{ width: { xs: "90vw", md: "40vw" }, margin: "5px", background: "linear-gradient(to right, #6716CC 0%, #074DC0 97%)", padding: "12px" }}
      >
        Submit
      </Button>
    </form>
  );
}

export default Form;
